module.exports = __webpack_public_path__ + "static/img/zsbj2.55c88a02.png";